
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BannerService } from '../../services/banner.service';
import { environment } from 'src/environments/environment';
import * as moment from "moment";
import { Table } from 'primeng/table';
import { Dropdown } from "primeng/dropdown";
import { RoleService } from '../../services/role.service';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { saveAs } from 'file-saver/src/FileSaver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // selector: 'app-list',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
  providers: [MessageService, ConfirmationService, TitleCasePipe, BannerService]
})

export class BannerComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  productDialog: boolean;
  bannerlist: any;
  submitted: boolean;
  cols: any[];
  staticPath: string;
  totalRecords: 0;
  errorMessage = '';
  loading: boolean;
  adminRoleId;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  statuses: any[];
  searchBy: any[];
  searchby: any;
  bannerImagePath;
  public bannerImage;
  bannerImage_src;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  displayImages: boolean;
  displayImages1: boolean;
  displayCustom: boolean;
  activeIndex: number = 0;
  paginationOption:any;
  public loggedInUser;
  public userId;
  public userRoleId;
  public bannerModule;
  public loggedInUserPermissions;
  public bannerPermissions: any[] = [];
  private lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  banner_title: any;
  mobile_banner_title: any;
  createdby: any;
  updatedby: any;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadbannerlist: any;

  constructor(private BannerService: BannerService, private router: Router, private roleService: RoleService, private messageService: MessageService, private confirmationService: ConfirmationService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.downloadFlg = false;  
    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;
    this.paginationOption = environment.pagination;
    this.bannerModule = "Banner Management";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();
    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.bannerModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.bannerPermissions.push(permissionObj);
      }
    });
    if (this.bannerPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.bannerPermissions = this.bannerPermissions[0]['permission'];
    this.bannerImagePath = environment.uploadUrl;
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.searchBy = [
        { label: 'Created On', value: "created_at" },
        { label: 'Last Modified On', value: "updated_at" }
    ];
    this.cols = [
      { field: 'banner_title', header: 'Title1223' },
      { field: 'banner_image', header: 'Image' },
      { field: 'banner_url', header: 'Banner Url' },
      { field: 'banner_content', header: 'Content' },
      { field: 'Status', header: 'Status' }
    ];
  }

  exportExcel() {
      this.downloadFlg = true;
      this.loadBanners(this.lastTableLazyLoadEvent);
      var propertiesRemove = ['id', 'created_at', 'createdby', 'updatedby', 'disable', 'updated_at', 'categoryId', 'brandcategoryId', 'status', 'created_by', 'Modification_Date'];
      this.downloadbannerlist = this.bannerlist;
      this.downloadbannerlist.forEach(function (item) {
          if (item.updated_at != '') {
              item['Modification_Date'] = moment(item.updated_at).format('DD/MM/YYYY');
          }
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });
      import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.downloadbannerlist);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "Bannermanagement");
      });
  }  

  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          let filename;
          filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
          saveAs(data, filename);
      });
  }

  addNewBanner() {
    this.router.navigate(['/manage/banner/add']);
  }

  editBanner(id) {
    this.router.navigate(['/manage/banner/' + id]);
  }

  onDelete(banner) {
    if (confirm("Are you sure to delete the record?")) {
      this.BannerService.deleteBanner(banner._id).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      })
    }
  }

  loadBanners(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (typeof event.rows === 'number' && !isNaN(event.rows)) {
      rows = event.rows;
    } else {
      rows = 10; 
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["banner_title"] != undefined) {
      params += "&filterByBannerTitle=" + event.filters["banner_title"].value;
    }
    if (event.filters != undefined && event.filters["mobile_banner_title"] != undefined) {
      params += "&filterByMobileBannerTitle=" + event.filters["mobile_banner_title"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdby"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdby"].value;
    }
    if (event.filters != undefined && event.filters["updated_at"] != undefined) {
      const updatedAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
      params += "&filterByUpdatedAt=" + updatedAt;
    }
    if (event.filters != undefined && event.filters["updatedby"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
    }
    // if (params != undefined && params != "") {
    //   query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    // } else {
    //   query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    // }
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
          query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
          query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
          query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    var querystring = "filterByroleName=admin";
    this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.BannerService.getbannerList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.loading = false;
          this.bannerlist = data.data.items;
          this.totalRecords = data.data.totalCount;
          this.bannerlist.forEach(element => {
            element.created_at = new Date(element.created_at);
            element.updated_at = new Date(element.updated_at);
          });
        },
        err => {
          this.errorMessage = err.error.message;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'banner_title', 'contains');
    this.dt.filter('', 'mobile_banner_title', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'createdby', 'contains');
    this.dt.filter('', 'updated_at', 'dateIs');
    this.dt.filter('', 'updatedby', 'contains');
    this.banner_title = '';
    this.mobile_banner_title = '';
    this.createdby = '';
    this.updatedby = '';
    this.calvalue = null;
    this.ucalvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  deleteBanner(banner) {
    this.confirmationService.confirm({   
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to delete this record ?
        </p>
      `,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (banner.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var bannerData = '{"disable":' + disableStatus + '}';
        this.BannerService.updateBanner(banner.id, bannerData).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Banner Deleted Successfully', life: 6000 });
          setTimeout(() => {
            this.loadBanners(this.lastTableLazyLoadEvent);
          }, 2000);
        },
        ((err) => {
          this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
        }));
      },
      reject: () => {
      }
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  changeStatus(banner) {
    this.confirmationService.confirm({
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to change this status ?
        </p>
      `, 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (banner.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var bannerData = '{"status":' + banner.status + '}';
        this.BannerService.updateBanner(banner.id, bannerData).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Banner Status Updated', life: 3000 });
          this.loadBanners(this.lastTableLazyLoadEvent);
        },err => {
          this.errorMessage = err.error.message;
        });
      },
      reject: () => {
        this.loadBanners(this.lastTableLazyLoadEvent);
      }
    });
  }

  addColumns() {
    this.hide = false;
  }
  
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}